/**
 * Created by alex.y on 9/11/2017.
 */
export enum CurrencyEnum {
    None = 0,
    USD = 1,
    CAD = 2
}


// WEBPACK FOOTER //
// ./app/objects/products/currencyEnum.ts